import { defineComponent as _defineComponent } from 'vue'
import { getCurrentInstance, withDefaults } from 'vue';

interface Props {
    addButtonLabel?: string;
    displayNextArrow?: boolean;
    displayPrevArrow?: boolean;
    disableAddButton?: boolean;
    disableNextButton?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CombinationsProductsControls',
  props: {
    addButtonLabel: { default: 'Add combination' },
    displayNextArrow: { type: Boolean, default: true },
    displayPrevArrow: { type: Boolean, default: false },
    disableAddButton: { type: Boolean, default: false },
    disableNextButton: { type: Boolean, default: false }
  },
  emits: ["prev", "next", "add"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'prev'): void;
    (e: 'next'): void;
    (e: 'add'): void;
}), expose: any, slots: any, attrs: any }) {





const { proxy } = getCurrentInstance()!;

return { __sfc: true,emit, proxy }
}

})